module.exports = __webpack_public_path__ + "static/media/info.53c640d0.svg";